import React from 'react';
import HeadTittle from '../../../../../../../components/HeadTittle';
import StepperTabs from '../../../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../../../components/StepperTabs/StepTab';
import { STEPS_ADD_USER_DEDUCTION_POLICY } from '../../DeductionPolicy/Model/Model';
import UpdateUserDeductionPolicyApp from '../Functionality/UpdateUserDeductionPolicyApp';
import StepSelectUser from './StepSelectUser';
import StepDeductionEntries from './StepDeductionEntries';
import StepGlobalRules from './StepGlobalRules';
import ButtonAction from "../../../../../../../components/buttons/ButtonAction";
import {CleanIcon, EditIcon} from "../../../../../../../components/buttons/IconButtons";
import ButtonIcon from "../../../../../../../components/buttons/ButtonIcon";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Update User Deduction Policy stepper view.
 * Pre-populates all steps from the server row passed via location state.
 * Steps: select user → deduction entries → exclude global deductions → summary.
 */
const UpdateUserDeductionPolicy = ({ disabled }) => {
    const {
        id,
        steps,
        canUpdate,
        activeStep, setActiveStep,
        handleStepChange,
        emptyFields, setEmptyFields,
        handleOnBack,
        user, setUser,
        deductions, setDeductions,
        excludedGlobalRules, setExcludedGlobalRules,
        selectForDelete, setSelectForDelete,
        searchElement, setSearchElement,
        modified, setModified,
        handleSubmit,
        handleClearStep
    } = UpdateUserDeductionPolicyApp();

    return (
        <>
            <HeadTittle
                onBack={handleOnBack}
                name={disabled ? "details" : "update"}
            >
                {canUpdate &&
                    <ButtonAction
                        id='btn_uud_update'
                        name={'update'}
                        className={'btn-icon-edit'}
                        Icon={EditIcon}
                        onClick={handleSubmit}
                    />
                }
            </HeadTittle>

            <StepperTabs
                id={id}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                {/* Step 1: Select user */}
                <StepTab index={STEPS_ADD_USER_DEDUCTION_POLICY.SELECT_USER.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_ADD_USER_DEDUCTION_POLICY.SELECT_USER.INDEX && (
                        <StepSelectUser
                            user={user}
                            setUser={setUser}
                            emptyFields={emptyFields}
                            disabled={true}
                        />
                    )}
                </StepTab>

                {/* Step 2: Deduction entries */}
                <StepTab index={STEPS_ADD_USER_DEDUCTION_POLICY.DEDUCTION_POLICY.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_ADD_USER_DEDUCTION_POLICY.DEDUCTION_POLICY.INDEX && (
                        <>
                            {!disabled &&
                                <div className="col-12 d-flex justify-content-end mb-2">
                                    <ButtonIcon
                                        id="btn_uud_clean_deductions"
                                        Icon={CleanIcon}
                                        onClick={() => handleClearStep(STEPS_ADD_USER_DEDUCTION_POLICY.DEDUCTION_POLICY.INDEX)}
                                        title="clear_instances"
                                        className="btn-clean-secondary-600"
                                        iconProps="btn-icon-svg-12px icon-color-general-00"
                                    />
                                </div>
                            }
                            <StepDeductionEntries
                                deductions={deductions}
                                setDeductions={setDeductions}
                                emptyFields={emptyFields}
                                setEmptyFields={setEmptyFields}
                                disabled={disabled}
                            />
                        </>
                    )}
                </StepTab>

                {/* Step 3: Select global deductions to exclude */}
                <StepTab index={STEPS_ADD_USER_DEDUCTION_POLICY.EXCLUDED_GLOBAL_DEDUCTIONS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_ADD_USER_DEDUCTION_POLICY.EXCLUDED_GLOBAL_DEDUCTIONS.INDEX && (
                        <StepGlobalRules
                            id={id}
                            excludedGlobalRules={excludedGlobalRules}
                            setExcludedGlobalRules={setExcludedGlobalRules}
                            selectForDelete={selectForDelete}
                            setSelectForDelete={setSelectForDelete}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            modified={modified}
                            setModified={setModified}
                            disabled={disabled}
                        />
                    )}
                </StepTab>
            </StepperTabs>
        </>
    );
};

export default UpdateUserDeductionPolicy;
